import entities from "./entities/de";
import pages from "./pages/de";
import globals from "./globals/de";
import formValidation from "./formValidation/de";
export default { entities, pages, globals, formValidation };
